// @flow
import { createAction } from "redux-actions";

// Fetch Public Evaluations
export const PUBLIC_EVALUATIONS_FETCH: string = "PUBLIC_EVALUATIONS_FETCH";
export const PUBLIC_EVALUATIONS_FETCH_REQUEST: string =
  "PUBLIC_EVALUATIONS_FETCH/REQUEST";
export const PUBLIC_EVALUATIONS_FETCH_SUCCESS: string =
  "PUBLIC_EVALUATIONS_FETCH/SUCCESS";
export const PUBLIC_EVALUATIONS_FETCH_FAILURE: string =
  "PUBLIC_EVALUATIONS_FETCH/FAILURE";
export const publicEvaluationFetch = createAction(PUBLIC_EVALUATIONS_FETCH);
export const publicEvaluationFetchRequest = createAction(
  PUBLIC_EVALUATIONS_FETCH_REQUEST
);
export const publicEvaluationFetchSuccess = createAction(
  PUBLIC_EVALUATIONS_FETCH_SUCCESS
);
export const publicEvaluationFetchFailure = createAction(
  PUBLIC_EVALUATIONS_FETCH_FAILURE
);
// Submit Public Evaluations
export const PUBLIC_EVALUATIONS_SUBMIT: string = "PUBLIC_EVALUATIONS_SUBMIT";
export const PUBLIC_EVALUATIONS_SUBMIT_REQUEST: string =
  "PUBLIC_EVALUATIONS_SUBMIT/REQUEST";
export const PUBLIC_EVALUATIONS_SUBMIT_SUCCESS: string =
  "PUBLIC_EVALUATIONS_SUBMIT/SUCCESS";
export const PUBLIC_EVALUATIONS_SUBMIT_FAILURE: string =
  "PUBLIC_EVALUATIONS_SUBMIT/FAILURE";
export const publicEvaluationsSubmit = createAction(PUBLIC_EVALUATIONS_SUBMIT);
export const publicEvaluationsSubmitRequest = createAction(
  PUBLIC_EVALUATIONS_SUBMIT_REQUEST
);
export const publicEvaluationsSubmitSuccess = createAction(
  PUBLIC_EVALUATIONS_SUBMIT_SUCCESS
);
export const publicEvaluationsSubmitFailure = createAction(
  PUBLIC_EVALUATIONS_SUBMIT_FAILURE
);
